import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import AdminApp from './Admin/AdminApp';
import ClinicianApp from './ClinicianApp';
import ClientApp from './Client/ClientApp';
import theme from './theme/theme';

const App = () => {
    const isAdminApp = process.env.REACT_APP_TYPE === 'Admin';
    const isClinicianApp = process.env.REACT_APP_TYPE === 'Clinician';
    const isClientApp = process.env.REACT_APP_TYPE === 'Client';
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUIXPREMIUM_LICENSE);
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                {isAdminApp && <AdminApp />}
                {isClinicianApp && <ClinicianApp />}
                {isClientApp && <ClientApp />}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
